import { Period } from './types';

export const PRESET_OPTIONS: Period[] = [
  { title_key: 'analytics.periods.today', days: 0, single: true },
  { title_key: 'analytics.periods.last_7_days', days: 6 },
  { title_key: 'analytics.periods.last_30_days', days: 29 },
  { title_key: 'analytics.periods.last_month', period: 'last_month' },
  { title_key: 'analytics.periods.week_to_date', period: 'week_to_date' },
  { title_key: 'analytics.periods.month_to_date', period: 'month_to_date' },
  { title_key: 'analytics.periods.quarter_to_date', period: 'quarter_to_date' },
];

// Opens the calendar in the compact (<640px) layout, where it cannot sit beside the presets.
export const CUSTOM_OPTION: Period = { title_key: 'analytics.periods.custom_open' };
